var ProductDataselectors = {
    productContainer: document.querySelector('.product-details-wrapper'),
    reviewratingEle: document.querySelector('.product-details-wrapper [data-hulkapps-reviews]'),
    productMedia: document.querySelector('[data-productMedia]'),
    zoomBtns: document.querySelectorAll('[data-productZoom]'),
    zoomContainer: document.querySelectorAll('.product-carousel .swiper-slide'),
    StickySlider: document.querySelector('[data-type= "slider"]'),
    header: document.querySelector('#header')
};

window.product_zoom = [];

var mediaJSON = null;
if (ProductDataselectors.productMedia != null) {
    mediaJSON = JSON.parse(ProductDataselectors.productMedia.innerHTML);
}
window.productMedia = mediaJSON;
class templateProductJS {
    constructor() {
        window.productMedia = mediaJSON;
        this._domEventListner();
        let headerHeight = ProductDataselectors.header.clientHeight
        if (ProductDataselectors.StickySlider != null) {
          ProductDataselectors.StickySlider.style.top = `${headerHeight}px`;
        }
        if (ProductDataselectors.reviewratingEle) {
            ProductDataselectors.reviewratingEle.addEventListener('click', (event) => {
                event.preventDefault();
                const reviewSection = document.querySelector('#hulk__product-review');
                if (reviewSection) reviewSection.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
            });
        }

        ProductDataselectors.zoomBtns.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                let currentTarget = event.target;
                this.manageZoom(currentTarget);
            })
        });
        this.productZoom();
    }

    manageVariantSlider(variant) {
        const productJSON = window.globalVariables.product;
        const productSliderType = ProductDataselectors.productContainer.dataset.slider_type;
        if (productSliderType == 'color-based' && productJSON.options && productJSON.options.includes('Color') || productJSON.options.includes('color') || productJSON.options.includes('COLOR')) {
            const currentVariant = variant || window.globalVariables.product.currentVariant;
            const colorName = currentVariant.option1.toLowerCase();
            const colorMedia = [];
            mediaJSON.forEach(media => {
                let mediaAlt = media.alt;
                if (mediaAlt) mediaAlt = mediaAlt.toLowerCase();
                if (mediaAlt == colorName) colorMedia.push(media);
            });
            window.productMedia = colorMedia;

            if (window.globalVariables.templateSuffix == 'layout2') {
                const imagesParent = document.querySelector('[data-productImagesContainer]');

                if (!imagesParent || colorMedia.length <= 0) return;
                let slidesHTML = '';
                colorMedia.forEach(function(i, v) {
                    let imageAlt = i.alt.toLowerCase();
                    if (imageAlt == colorName) {
                        if (i.media_type == "external_video") {
                            slidesHTML += `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn" data-aos="hero">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        } else if (i.media_type == "video") {
                            slidesHTML += `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        } else {
                            slidesHTML += `<div class="product--media col-6 my-md-2 my-1 px-md-2 px-1 position-relative" data-mediaID="${i.id}" data-media-url="${i.src}" role="treeitem">
                            <div data-productZoom class="product-zoom"><i class="icon-search-plus-solid"></i></div>
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                        }
                    }
                });
                imagesParent.innerHTML = slidesHTML;
            } else {
                const thumbParent = document.querySelector('[data-thumbSlider]');
                const sliderParent = document.querySelector('[data-main-slider]');

                if (!thumbParent || !sliderParent || colorMedia.length <= 0) return;

                let thumbnailsHTML = '';
                let slidesHTML = '';
                colorMedia.forEach(function(i, v) {
                    let imageAlt = i.alt.toLowerCase();
                    if (imageAlt == colorName) {
                        if (i.media_type == "external_video") {
                            thumbnailsHTML += `<div class="swiper-slide product-thumb--image media--video" data-mediaID="${i.id}" data-media-url="${i.src}" role="treeitem">
                            <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                                <i class="icon-play position-absolute"></i>
                                <div class="thumb-video-overlay">
                                    <svg width="21.5" height="21.5" viewBox="0 0 21.5 21.5">
                                    <g id="Group_692" data-name="Group 692" transform="translate(0.25 0.15)">
                                        <g id="Group_693" data-name="Group 693" transform="translate(0.5 0.6)">
                                        <circle id="Ellipse_6" data-name="Ellipse 6" cx="10" cy="10" r="10" fill="none" stroke="#fff" stroke-width="1.5"></circle>
                                        <path id="Path_1258" data-name="Path 1258" d="M14.061,9.943,8.5,6.607v6.673Z" transform="translate(-0.343 0.152)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
                                        </g>
                                    </g>
                                    </svg>
                                </div>
                            </div>`;
                            slidesHTML += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" data-media-url="${i.src}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="${i.host}" data-video-id="${i.external_id}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn" data-aos="hero">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        } else if (i.media_type == "video") {
                            thumbnailsHTML += `<div class="swiper-slide product-thumb--image media--video" data-mediaID="${i.id}" role="treeitem">
                            <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                                <i class="icon-play position-absolute"></i>
                                <div class="thumb-video-overlay">
                                    <svg width="21.5" height="21.5" viewBox="0 0 21.5 21.5">
                                    <g id="Group_692" data-name="Group 692" transform="translate(0.25 0.15)">
                                        <g id="Group_693" data-name="Group 693" transform="translate(0.5 0.6)">
                                        <circle id="Ellipse_6" data-name="Ellipse 6" cx="10" cy="10" r="10" fill="none" stroke="#fff" stroke-width="1.5"></circle>
                                        <path id="Path_1258" data-name="Path 1258" d="M14.061,9.943,8.5,6.607v6.673Z" transform="translate(-0.343 0.152)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>
                                        </g>
                                    </g>
                                    </svg>
                                </div>
                            </div>`;
                            slidesHTML += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" role="treeitem">
                                <div class="custom-video-container">
                                    <custom-video class="placement--grid" data-video-type="local" data-video-id="${i.sources[0].url}" data-placement="grid" data-autoplay="true" data-controls="true">
                                        <div class="cta-btn">
                                            <button class="play__button btn btn-primary" data-trigger-video aria-label="Play Video">
                                                <i class="icon-play text-body"></i>
                                            </button>
                                            <button class="pause__button btn btn-primary" data-pause-video aria-label="Pause Video">
                                                <i class="icon-pause"></i>
                                            </button>
                                        </div>
                                        <div class="content-section">
                                            <div class="poster-image">
                                                <img class="img-fluid"
                                                src="${i.preview_image.src}"
                                                alt="${i.alt}"/>
                                            </div>
                                        </div>
                                        <div class="video-section" tabindex="0"></div>
                                    </custom-video>
                                </div>
                            </div>`;
                        } else {
                            thumbnailsHTML += `<div class="swiper-slide product-thumb--image" data-mediaID="${i.id}" role="treeitem">
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                            slidesHTML += `<div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="${i.id}" data-media-url="${i.src}" role="treeitem">
                                <div data-productZoom class="product-zoom"><i class="icon-search-plus-solid"></i></div>
                                <img class="img-fluid"
                                src="${i.preview_image.src}"
                                alt="${i.alt}"/>
                            </div>`;
                        }
                    }
                });

                let navDirection = thumbParent.dataset.direction || 'horizontal';
                let finalnavHTML = `
                    <div class="swiper-slider product-thumbnails" role="tree" 
                            data-slider='{
                                "direction": "${navDirection}",
                                "loop": false,
                                "slidesPerView": "6",
                                "spaceBetween": 15,
                                "grabCursor": true,
                                "slideToClickedSlide": true
                            }' >
                        <div class="swiper-wrapper">${thumbnailsHTML}</div>
                    </div>`;
                thumbParent.innerHTML = finalnavHTML;

                let finalHTML = `<slider-element class="swiper-container carousel">
                                    <div class="swiper swiper-slider product-carousel pdp-carousel" data-nav="product-thumbnails"
                                        data-slider='{
                                                "loop": false,
                                                "slidesPerView": "1",
                                                "spaceBetween": 15,
                                                "grabCursor": true,
                                                "navigation": {
                                                    "nextEl": ".swiper-button-next",
                                                    "prevEl": ".swiper-button-prev"
                                                },
                                                "pagination": {
                                                    "el": ".swiper-pagination"
                                                }
                                            }' role="tree">
                                        <div class="swiper-wrapper" >${slidesHTML}</div>
                                        <div class="swiper-pagination"></div>
                                    </div>
                                </slider-element>`;
                sliderParent.innerHTML = finalHTML;
            }

            ProductDataselectors.zoomBtns = document.querySelectorAll('[data-productZoom]');
            ProductDataselectors.zoomBtns.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    let currentTarget = event.target;
                    this.manageZoom(currentTarget);
                })
            });
        }
    }

    productZoom() {
        if (window.innerWidth >= 768) {
            var selectedImage = document.querySelectorAll('.product--media img');
            var zoomWrapper = document.querySelector('.product-zoom-container');
            // setTimeout(() => {
            //     selectedImage.forEach((item) => {
            //         new Drift(item, {
            //             paneContainer: zoomWrapper,
            //             inlinePane: 900,
            //             inlineOffsetY: -85,
            //             containInline: true,
            //             hoverBoundingBox: true,
            //         });
            //         item.style.cursor = 'crosshair';
            //     })
            // }, 3000);
            var checkProductMedia = setInterval(() => {
                if(selectedImage) { 
                    clearInterval(checkProductMedia)
                    selectedImage.forEach((item) => {
                        new Drift(item, {
                            paneContainer: zoomWrapper,
                            inlinePane: 900,
                            inlineOffsetY: -85,
                            containInline: true,
                            hoverBoundingBox: true,
                        });
                        item.style.cursor = 'crosshair';
                    })
                }
            }, 100);   
        }
    }
    _domEventListner = () => {
        document.addEventListener('input', (event) => {
            if (event.target.closest('#giftCardAmount')) {
                let Inputvalue = event.target.value;
                if (event.data == 'e') {
                    let ipValue = event.target.value;
                    event.target.value = ipValue.slice(0, -1);
                }
            }
        })
    }

}
window.onload = () => {
    typeof templateProductJS !== 'undefined' && new templateProductJS();
}

// productZoom trigger
// (() => {
//     var options = {};
//     var media_div = ProductDataselectors.zoomContainer
//     for (i = 1; i, i <= media_div.length; i++) {
//         if (document.getElementById(`img-container-${i}`) != null) {
//             window.product_zoom.push(new ImageZoom(document.getElementById(`img-container-${i}`), options));
//         }
//     }
// })();

// document.querySelectorAll('.js-image-zoom__zoomed-image').forEach(element => {
//     document.querySelector('.product-details-wrapper').appendChild(element)
// })


//favourite products count
var wishlistInterval = setInterval(() => {
    var favCount = document.querySelector('.swym-fave-count');
    if (favCount != null && favCount.getAttribute('data-count') != null) {
        favCount = favCount.getAttribute('data-count');
        if (document.querySelector('[data-wishlistCount]') != null) {
            document.querySelector('[data-wishlistCount]').innerHTML = `${favCount}`;
        }
        if (document.querySelector('.swym-fave-count') != null) {
            var targetNode = document.querySelector('.swym-btn-container');
            var config = { childList: true, subtree: true };

            var callback = function(mutationsList, observer) {
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        observer.disconnect();
                        _wishlistCount();
                        observer.observe(targetNode, config);
                    }
                }
            };
            var observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
            clearInterval(wishlistInterval)
        }
    }
}, 1000);

_wishlistCount = () => {
    var favCount = document.querySelector('.swym-fave-count').getAttribute('data-count')
    document.querySelector('[data-wishlistCount]').innerHTML = `${favCount}`
    if (document.querySelector('.swym-fave-count')) {
        clearInterval(wishlistInterval)
    }
}

document.addEventListener('click', (event) => {
    if (event.target.closest('[data-swaction="addToWishlist"]:not(.swym-added)') != null) {
        document.querySelector('.swym-button').click();
    }
})
// if(document.querySelector("[data-giftWrappedCheckbox]") != null){
//   document.querySelector("[data-giftWrappedCheckbox]").addEventListener('change', (event) => {
//     document.querySelector('[div-giftWrappedMsg]').classList.toggle('d-none');
//     if (event.currentTarget.checked) {
//       document.querySelector('[div-giftWrappedMsg] textarea').removeAttribute('disabled');
//       document.querySelector('[data-propertiesgift]').value = 'Yes';
//     } else {
//       document.querySelector('[div-giftWrappedMsg] textarea').setAttribute('disabled', 'disabled');
//       document.querySelector('[data-propertiesgift]').value = 'No';
//     }
//   });
// }

document.addEventListener('DOMContentLoaded', () => {
  function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  }

  waitForElm('.afterpay-link').then((elm) => {
    const moveContentToModal = () => {
        const appendContent = () => {
            const afterPayModalContent = document.querySelector('#afterpay-modal-container #afterpay-modal-content');
            if (afterPayModalContent) {
              const afterPayModal = document.querySelector('#afterpay-modal-container #afterpay-modal-modal');
              afterPayModal.appendChild(afterPayModalContent);
            }
            document.removeEventListener('afterpayModalLoaded', appendContent);
        }
      document.addEventListener('afterpayModalLoaded', appendContent);
      
      elm.removeEventListener('click', moveContentToModal);
    };
  
    elm.classList.add('loaded');
    elm.addEventListener('click', moveContentToModal);
  }); 
})
